import { computed } from "vue";
export function useCommonVars() {
  var curLanguage = computed(() => document.documentElement.getAttribute("lang") || "it");
  var cdn = computed(() => window["_cdn"]);
  var wkLabels = computed(() => window["_labels"]);
  var options = computed(() => window["_options"]);
  var baseURLIt = computed(() => window["_baseURLIt"]);
  var baseURL = computed(() => window["_baseURL"]);
  return {
    curLanguage,
    cdn,
    wkLabels,
    options,
    baseURLIt,
    baseURL
  };
}